import { render } from "./SideBar.vue?vue&type=template&id=7eac1e9e&scoped=true&ts=true"
import script from "./SideBar.ts?vue&type=script&lang=ts"
export * from "./SideBar.ts?vue&type=script&lang=ts"

import "./SideBar.scss?vue&type=style&index=0&id=7eac1e9e&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eac1e9e"]])

export default __exports__